import React from "react";

interface CelebrationButtonProps {
  borderColor?: string;
  fillColor?: string;
}

export const CelebrationButtonOutline: React.FC<CelebrationButtonProps> = ({
  borderColor = "yellow-300",
  fillColor = "yellow-100",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="39"
      viewBox="0 0 34 39"
      fill="none"
    >
      {/* Outer border */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C2.68629 0 0 2.68629 0 6V28C0 31.3137 2.68629 34 6 34H11.6184L15.6716 38.644C15.7759 38.756 15.9036 38.8456 16.0463 38.907C16.1891 38.9683 16.3436 39 16.5 39C16.6563 39 16.8109 38.9683 16.9537 38.907C17.0964 38.8456 17.2241 38.756 17.3284 38.644L21.3816 34H28C31.3137 34 34 31.3137 34 28V6C34 2.68629 31.3137 0 28 0H6Z"
        fill={`var(--color-${borderColor})`}
      />
      {/* Inner fill - 2px smaller to create border effect */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C3.79086 2 2 3.79086 2 6V28C2 30.2091 3.79086 32 6 32H12.2368L16.5 36.8L20.7632 32H28C30.2091 32 32 30.2091 32 28V6C32 3.79086 30.2091 2 28 2H6Z"
        fill={`var(--color-${fillColor})`}
      />
    </svg>
  );
};
